import { render, staticRenderFns } from "./LandingView.vue?vue&type=template&id=5543c753&scoped=true"
import script from "./LandingView.vue?vue&type=script&lang=js"
export * from "./LandingView.vue?vue&type=script&lang=js"
import style0 from "./LandingView.vue?vue&type=style&index=0&id=5543c753&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5543c753",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5543c753')) {
      api.createRecord('5543c753', component.options)
    } else {
      api.reload('5543c753', component.options)
    }
    module.hot.accept("./LandingView.vue?vue&type=template&id=5543c753&scoped=true", function () {
      api.rerender('5543c753', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Landing/LandingView.vue"
export default component.exports